import React, { useEffect, useState } from 'react'
import { Dropdown } from 'primereact/dropdown';
import { Spinner } from 'react-bootstrap';
import { Dialog } from 'primereact/dialog';

import ChangeTemplatesLayouts from './Edit/ChangeTemplatesLayouts';
import ChangeCustomLayouts from './Edit/ChangeCustomLayouts';
import EditLayout from './Edit/EditLayout';

import { useSelector, useDispatch } from 'react-redux';
import { toggleDialog } from '../../../../../redux/Slices/Global/globalSlice';
import { useFetchTemplates } from '../../../../../queries/layouts';
import { useTranslation } from 'react-i18next';

function EditLayoutPopUp() {
  const { t } = useTranslation();
  const { openDialog } = useSelector((state) => state.global);

  const dispatch = useDispatch()
  const [activeIndex, setActiveIndex] = useState(0);
  const [currentPage, setCurrentPage] = useState(0);
  const [totalRecords, setTotalRecords] = useState(0);
  const [isMaximized, setIsMaximized] = useState(true);
  const { data, isLoading, refetch } = useFetchTemplates(currentPage);

  useEffect(() => {
    if (data?.totalRecords !== undefined) {
      setTotalRecords(data.totalRecords);
    }
  }, [data]);


  const items = [
    {
      label: t('layouts.setup_customizing_current'),
      value: 0,
      command: () => setActiveIndex(0),
    },
    {
      label: t('layouts.custom_layouts'),
      value: 1,
      command: () => setActiveIndex(1),
    },
    {
      label: t('layouts.setup_default_templates'),
      value: 2,
      command: () => setActiveIndex(2),
    },
  ];

  useEffect(() => {
    refetch();
  }, [currentPage]);


  const renderContent = () => {
    switch (activeIndex) {
      case 0:
        return <EditLayout 
          isMaximized={isMaximized} 
          activeIndex={activeIndex} 
          setActiveIndex={setActiveIndex} 
          navItems={items} 
        />;
      case 1:
        return (<ChangeCustomLayouts
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          totalRecords={totalRecords}
        />);

      case 2:
        return <ChangeTemplatesLayouts />;

      default:
        return null;
    }
  };


  const customHeader = (
    <div className="flex justify-between items-center w-full">
      <span className="text-lg font-semibold">{t('layouts.setup_edit_your_layout')}</span>
      <div className="items-center flex w-[25%]">

        <Dropdown
          value={activeIndex}
          options={items}
          optionLabel="label"
          optionValue="value"
          className="mx-2 w-100"
          onChange={(e) => {
            setActiveIndex(e.value);
          }}
          placeholder={t('layouts.setup_select_unit')}
        />

      </div>
    </div>
  );

  return (
    <Dialog visible={openDialog.EditLayoutPopUp}
      breakpoints={{ '960px': '95vw' }}
      header={customHeader}
      showHeader={activeIndex !== 0}
      style={{ overflow: 'hidden' }}
      modal
      blockScroll={true}
      className={`p-fluid w-full ${isMaximized ? 'p-dialog-maximized' : 'p-dialog-default md:w-[100%] lg:w-[75%] h-[85%]'}`}
      onHide={() => dispatch(toggleDialog("EditLayoutPopUp"))}
    >
      <div className="scroll_div overflow-x-hidden h-full">

        {/* <TabMenu className='pe-5 pl-5' model={items} activeIndex={activeIndex} onTabChange={(e) => setActiveIndex(e.index)} /> */}
        {
          isLoading ?
            <div className="col-12 d-flex justify-content-center p-4 border-top border-gray">
              <Spinner as="span" variant="primary" size='lg' animation="border" role="status" className='mx-3 my-5 ' aria-hidden="true" />
            </div> :
            <div className="scroll_div flex flex-col   overflow-y-auto h-full" >
              {renderContent()}
            </div>
        }

      </div>

    </Dialog>
  )
}

export default EditLayoutPopUp